<div class="col-sm-12 p-4">
    <div class="page-body m-0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 row">
                    <!-- <button *ngIf="(roleId == 6 || roleId == 7) && allowToVote == true && DecsionOList == null" (click)="CreateVote(AddVote)"
       class="btn btn-secondary m-2">
       <i class="fa fa-plus"></i> {{ "InsertVote" | translate }}</button>&nbsp;
    -->
                    <!-- *ngIf="(roleId == 6 || roleId == 7) && allowToVote == true && DecsionOList == null" -->
                    <div class="col-lg-4">&nbsp;</div>
                    <div class="col-lg-4" *ngIf="(roleId == 6 || roleId == 7) && allowToVote == true && DecsionOList == null">
                        <div *ngIf="signatureSrc!=null" class="form-group row col-12" style="justify-content: space-between;">
                            <p style="text-align:center;">
                                {{'PleaseVote'  |translate}}  
                            </p>
                            <div class="row col-12">
                                <div *ngFor="let item of DecsionTypeArr" [ngClass]="{'selected2':(item.id==decsionTypeId && item.id==2) , 'selected1':(item.id==decsionTypeId && item.id==1)   }"
                                     (click)="CreateVote(item.id,selectVote)" class="col-5 btnVote" style="margin:5px">
                                    <div class="circle">
                                        <i *ngIf="item.id==1" class="fa fa-close"></i>
                                        <i *ngIf="item.id==2" class="fa fa-check"></i>

                                    </div>


                                    {{item.text}}
                                </div>
                            </div>
                        </div>
<div *ngIf="signatureSrc==null">
{{'PleaseUploadYourSignatureImageOnYourProfileToBeAbleToVote'|translate}}
</div>
                    </div>
                    <div class="col-12" style="text-align: left">
                        <button *ngIf="DecsionOList != null" (click)="PrintDecision()" class="btn btn-secondary m-2">
                            <i class="fa fa-print"></i> {{ "PrintDecision" | translate }}
                        </button>
                    </div>
                </div>

                    <div class="  col-12" [hidden]="roleId==8">
                        <div style="margin: 20px 90px;">

                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ "userDisplayname" | translate }}</th>
                                        <th scope="col">{{ "DecsionTypeName" | translate }}</th>

                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of voteList; let i = index">
                                        <td>
                                            {{ item.userDisplayname }}
                                        </td>
                                        <td>
                                            {{ item.decsionTypeName}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>


                        </div>
                    </div>

                    <br />
                    <br />

                    <!-- Decsion -->
                    <hr />


                    <div>
                        <span>{{'Suggestiondecision' | translate}} :  {{ suggestedDecision }}</span>
                       
                    </div>
                    <div *ngIf="lengthVote >= 2">
                        <div class="row" *ngIf="roleId == 7 ||caseObject.caseStatusId>8 ">
                            <div class="row col-12">
                                <h4 class="text-center">
                                    {{ "DecsionTypeName" | translate }} -
                                    <span style="font-weight: bold">{{ decsionNumber }} / {{ decsionhijriYear }}</span>
                                </h4>
                                <div *ngIf="roleId != 7  || caseObject.caseStatusId>8" class="col-4">
                                    <h6 *ngIf="decsiontypeId == 1" style="font-weight: bold">
                                        {{ DecsionTypeArr[0].text }}
                                    </h6>
                                    <h6 *ngIf="decsiontypeId == 2" style="font-weight: bold">
                                        {{ DecsionTypeArr[1].text }}
                                    </h6>

                                    <p>{{descriptionDesion}}</p>


                                </div>

                                <br />

                                <div class="col-12 col" *ngIf="(caseObject.caseStatusId==8 && roleId == 7) ">
                                    <!-- <div class="col-3">
                      <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label for="">{{ "decsionType" | translate }}</label>
                        <span *ngIf="decisionType.invalid" class="alert"
                          style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                          <div *ngIf="decisionType.errors?.required">
                            *
                          </div>
                        </span>
                      </div>
                    </div> -->
                                    <div class="col-lg-4">
                                        <div class="form-group row col-12" style="justify-content: space-between;">
                                            <p style="margin:2px ;">
                                                {{ "decsionType" | translate }} :
                                            </p>
                                            <div class="row col-12">
                                                <div *ngFor="let item of DecsionTypeArr" [ngClass]="{'selected2':(item.id==decsionId && item.id==2) , 'selected1':(item.id==decsionId && item.id==1)   }"
                                                     (click)="DecsionSelected(item.id)" class="col-5 btnVote" style="margin:5px">
                                                    <div class="circle">

                                                        <i *ngIf="item.id==1" class="fa fa-close"></i>
                                                        <i *ngIf="item.id==2" class="fa fa-check"></i>

                                                    </div>
                                                    {{item.text}}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- <div class="col-12">
                      <ng-select [items]="DecsionTypeArr" bindLabel="text" bindValue="id" class="form-control-select"
                        [(ngModel)]="decsionId" [ngModelOptions]="{ standalone: true }"
                        [disabled]="roleId != 7 && allowToVote == true" (change)="changeDecsion($event)"
                        #decisionType="ngModel" required>
                      </ng-select>
                    </div> -->
                                    <br>
                                    <div class="col-3 m-2">
                                        <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                                            <label for="">{{ "decsionDescription" | translate }}</label>
                                            <span *ngIf="DescriptionDesion.invalid" class="alert"
                                                  style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                                <div *ngIf="DescriptionDesion.errors?.required">
                                                    *
                                                </div>
                                            </span>
                                        </div>
                                    </div>

                                    <textarea rows="10" [(ngModel)]="descriptionDesion" class="form-control"
                                              pattern="^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z0-9\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z0-9\s-_]*$"
                                              name="descriptionDesion" required #DescriptionDesion="ngModel"
                                              required></textarea>
                                    <br />
                                    <!-- [disabled]="decsionId.invalid" -->
                                </div>







                                <!-- [disabled]="DecsionOList != null || DescriptionDesion.invalid || decisionType.invalid" -->

                                <div class="col-12" style="text-align: center;
                margin-right: auto;" *ngIf="(caseObject.caseStatusId==8 && roleId == 7) || allowToVote == true">
                                    <button type="button" class="btn btn-primary"
                                            [hidden]="roleId != 7 && allowToVote == true" (click)="open(makeDecision)">
                                        {{ "SaveDecsion" | translate }}
                                    </button>
                                    <button *ngIf="DecsionOList != null" (click)="PrintDecision()" class="btn btn-secondary m-2">
                                        <i class="fa fa-print"></i> {{ "PrintDecision" | translate }}
                                    </button>
                                    <!-- [disabled]="descriptionDesion.invalid || decsionId.invalid"  -->
                                    <button *ngIf="DecsionOList == null && roleId == 7 "
                                            (click)="PreviewDecision()"
                                            class="btn btn-secondary m-2">
                                        <i class="fa fa-print"></i> {{ "PreviewDecision" | translate }}
                                    </button>
                                </div>


                            </div>
                            <hr />

                        </div>
                    </div>
                </div>
        </div>
    </div>

 

    <ng-template #makeDecision let-modal>
        <div class="modal-header" style="justify-content: center">
            <h4 class="modal-title" id="modal-basic-title">
                {{ "SaveDecsion" | translate }}
            </h4>
        </div>
        <div class="modal-body">

            {{'TheDecisionWillBeSend' | translate}}  <br />
            <img *ngIf="loading" style="height:30px;" src="../../../../../assets/images/loader.gif" />
        </div>  
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="CreateDecsion()" [disabled]="decsended">
                {{ "SaveDecsion" | translate }}
            </button>
            <button type="button" class="btn btn-danger" (click)="modal.dismiss('Cross click')">
                {{ "NO" | translate }}
            </button>
        </div>
    </ng-template>


    <ng-template #selectVote let-modal>
        <div class="modal-header" style="justify-content: center">
            <h4 class="modal-title" id="modal-basic-title">
                {{'EnterTheVerificationCode' | translate}}
            </h4>
        </div>
        <div class="modal-body">


            <div class="container height-100 d-flex justify-content-center align-items-center">
                <div class="position-relative">
                    <div class="card p-2 text-center">
                        

                        <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2 row">
                            <p class="col-12">{{'PleaseEnterTheVerificationCodeToValidateYourVoteOnTheDecision' | translate}}</p><br />
                           <div class="col-12">
                              <input class="m-2 text-center form-control rounded" type="text" id="first" maxlength="4" [(ngModel)]="otp" />

                              </div>
                            
                        </div>
                        <!-- <div class="mt-4"> <button class="btn btn-danger px-4 validate">Validate</button> </div> -->
                    </div>
                </div>
            </div>


        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="voteSelected()">
                {{ "YES" | translate }}
            </button>
            <button type="button" class="btn btn-danger" (click)="modal.dismiss('Cross click')">
                {{ "NO" | translate }}
            </button>
        </div>
    </ng-template>
